<template>
  <Layout title="HR Management" description="Comprehensive employee management system">
    <div class="space-y-6">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="fw-bold fs-4">Employee Management</h2>
        <button class="btn btn-primary rounded-pill px-4" style="background: linear-gradient(90deg,#a855f7,#ec4899); border: none;"  @click="showAddModal = true" >
          Add New Employee
        </button>
      </div>
      
        <!-- Add Employee Modal -->
        <div
        v-if="showAddModal"
        class="modal d-block"
        style="z-index: 1050;"
        >
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content rounded-4 shadow">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title fw-bold">Add New Employee</h5>
                <button type="button" class="btn-close" @click="showAddModal = false"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
                <form @submit.prevent="createEmployee">

                <!-- Identity -->
                <h6 class="fw-bold mt-3 mb-3">Identity</h6>
                <div class="row g-3">
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Legal Name *" v-model="newEmployee.legalName" required />
                    </div>
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Preferred Name" v-model="newEmployee.name" />
                    </div>
                    <div class="col-md-6">
                    <input type="date" class="form-control" placeholder="Date of Birth *" v-model="newEmployee.dob" required />
                    </div>
                    <div class="col-md-6">
                    <select class="form-select" v-model="newEmployee.employeeStatus">
                        <option value="Active">Active</option>
                        <option value="Pending">Pending</option>
                        <option value="Probation">Probation</option>
                        <option value="Resigned">Resigned</option>
                        <option value="Terminated">Terminated</option>
                    </select>
                    </div>
                </div>

                <!-- Contact -->
                <h6 class="fw-bold mt-4 mb-3">Contact</h6>
                <div class="row g-3">
                    <div class="col-md-6">
                    <input type="email" class="form-control" placeholder="Personal Email *" v-model="newEmployee.personalEmail" required />
                    </div>
                    <div class="col-md-6">
                    <input type="email" class="form-control" placeholder="Work Email *(Login Email)" v-model="newEmployee.email" required />
                    </div>
                    <div class="col-md-6">
                    <input type="password" minlength="6" class="form-control" placeholder="Password *(Login Password)" v-model="newEmployee.password" required />
                    </div>
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Mobile Number *" v-model="newEmployee.mobileNumber" required />
                    </div>
                    <div class="col-md-12">
                    <textarea class="form-control" placeholder="Home Address *" rows="1" v-model="newEmployee.homeAddress" required></textarea>
                    </div>
                </div>

                <!-- Job Info -->
                <h6 class="fw-bold mt-4 mb-3">Job Info</h6>
                <div class="row g-3">
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Job Title *" v-model="newEmployee.position" required />
                    </div>
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Department *" v-model="newEmployee.department" required />
                    </div>
                    <div class="col-md-6">

                        <v-select
                            v-model="newEmployee.managerId"
                            :options="employees"
                            label="name"
                            :reduce="manager => manager.id"
                            placeholder="Type or select manager"
                        >
                            <template #option="{ name, id }">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span>{{ name }}</span>
                                    <small class="text-muted ms-2">({{ id }})</small>
                                </div>
                            </template>
                        </v-select>
                    </div>


                    <div class="col-md-6">
                    <select class="form-select" v-model="newEmployee.employmentType">
                        <option value="Permanent">Permanent</option>
                        <option value="Contract">Contract</option>
                        <option value="Intern">Intern</option>
                        <option value="Part-time">Part-time</option>
                    </select>
                    </div>
                    <div class="col-md-6">
                    <select class="form-select" v-model="newEmployee.workArrangement">
                        <option value="Hybrid">Hybrid</option>
                        <option value="Onsite">Onsite</option>
                        <option value="Remote">Remote</option>
                    </select>
                    </div>
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Work Location/Site" v-model="newEmployee.workLocation" />
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Join Date</label>
                    <input type="date" class="form-control" placeholder="Join Date *" v-model="newEmployee.joinDate" required />
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Probation End Date</label>
                    <input type="date" class="form-control" placeholder="Probation End Date" v-model="newEmployee.probationEndDate" />
                    </div>
                </div>

                <!-- <h6 class="fw-bold mt-4 mb-3">Payroll</h6>
                <div class="row g-3">
                    <div class="col-md-6">
                    <select class="form-select" v-model="newEmployee.payroll.employmentBasis">
                        <option value="fulltime">Full-time</option>
                        <option value="parttime">Part-time</option>
                    </select>
                    </div>

                    <template v-if="newEmployee.payroll.employmentBasis === 'fulltime'">
                        <div class="col-md-6">
                            <input 
                            type="number" 
                            class="form-control" 
                            placeholder="Base Salary Amount *" 
                            v-model="newEmployee.payroll.baseSalary" 
                            />
                        </div>

                        <div class="col-md-6">
                            <select class="form-select" v-model="newEmployee.payroll.currency">
                            <option disabled value="">Select Currency</option>
                            <option value="SGD">SGD</option>
                            </select>
                        </div>

                        <div class="col-md-6">
                            <select class="form-select" v-model="newEmployee.payroll.paySchedule">
                            <option disabled value="">Select Pay Schedule</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                            </select>
                        </div>

                        <div class="col-md-6" v-if="newEmployee.payroll.paySchedule === 'Monthly'">
                            <input 
                            type="number" 
                            class="form-control" 
                            placeholder="Enter Day of Month (1-31)" 
                            min="1" max="31"
                            v-model.number="newEmployee.payroll.generateDay"
                            />
                        </div>

                        <div class="col-md-6" v-if="newEmployee.payroll.paySchedule === 'Weekly'">
                            <select class="form-select" v-model="newEmployee.payroll.generateWeekday">
                            <option disabled value="">Select Payroll Day</option>
                            <option value="Mon">Mon</option>
                            <option value="Tue">Tue</option>
                            <option value="Wed">Wed</option>
                            <option value="Thu">Thu</option>
                            <option value="Fri">Fri</option>
                            </select>
                        </div>

                        <div class="col-md-12 d-flex align-items-center">
                            <label class="form-label fw-semibold me-3 mb-0">Attendance Required</label>
                            <div class="form-check form-switch">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newEmployee.payroll.attendanceRequired"
                                id="attendanceSwitchFulltime"
                            />
                            </div>
                        </div>
                        </template>

                        <template v-else>
                        <div class="col-md-6">
                            <input 
                            type="number" 
                            class="form-control" 
                            placeholder="Hourly Rate *" 
                            v-model="newEmployee.payroll.hourlyRate" 
                            />
                        </div>

                        <div class="col-md-6">
                            <select class="form-select" v-model="newEmployee.payroll.generateWeekday">
                            <option disabled value="">Select Payroll Day</option>
                            <option value="Mon">Mon</option>
                            <option value="Tue">Tue</option>
                            <option value="Wed">Wed</option>
                            <option value="Thu">Thu</option>
                            <option value="Fri">Fri</option>
                            </select>
                        </div>

                        <div class="col-md-6 d-flex align-items-center">
                            <label class="form-label fw-semibold me-3 mb-0">Attendance Required</label>
                            <div class="form-check form-switch">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newEmployee.payroll.attendanceRequired"
                                id="attendanceSwitchParttime"
                            />
                            </div>
                        </div>
                    </template>



                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Bank Account Name" v-model="newEmployee.payroll.bankDetails.accountName" />
                    </div>
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Bank Name" v-model="newEmployee.payroll.bankDetails.bankName" />
                    </div>
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Branch Code" v-model="newEmployee.payroll.bankDetails.branchCode" />
                    </div>
                    <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="Account Number" v-model="newEmployee.payroll.bankDetails.accountNumber" />
                    </div>
                </div> -->

                <!-- Leave Entitlements -->
                <h6 class="fw-bold mt-4 mb-3">Leave Entitlements</h6>
                <div class="row g-3">
                    <div class="col-md-3" v-for="(leave, index) in newEmployee.leaveEntitlements" :key="index">
                    <label class="form-label">{{ leave.type }}</label>
                    <input type="number" class="form-control" v-model.number="leave.entitlement" placeholder="Days" />
                    </div>
                </div>

                <!-- System Access -->
                <h6 class="fw-bold mt-4 mb-3">System Access</h6>
                <div class="row g-3 align-items-stretch">
                <div
                    class="col-md-6 col-lg-4 d-flex"
                    v-for="(access, index) in newEmployee.systemAccess"
                    :key="index"
                >
                    <div class="card shadow-sm flex-fill h-100">
                    <div class="card-body d-flex justify-content-between align-items-center">
                        <div>
                        <div class="fw-semibold">{{ access.name }}</div>
                        <small class="text-muted">{{ access.desc }}</small>
                        </div>
                        <div class="form-check form-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="access.enabled"
                            :id="'access-' + index"
                        />
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                </form>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary rounded-pill"
                    @click="showAddModal = false"
                    :disabled="savingLoading"
                >
                    Cancel
                </button>

                <button
                    type="button"
                    class="btn btn-primary rounded-pill d-flex align-items-center justify-content-center"
                    @click="createEmployee"
                    :disabled="savingLoading"
                >
                    <span v-if="savingLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <span>{{ savingLoading ? 'Saving...' : 'Save Employee' }}</span>
                </button>
            </div>

            </div>
        </div>
        </div>


      <!-- Employee Cards -->
      <div class="row g-3">
        <div
            v-for="(employee, index) in employees"
            :key="index"
            class="col-12 col-md-4"
            @click="selectEmployee(employee)"
        >
          <div class="card border-0 shadow-sm h-100 rounded-4 hover-card">
            <div class="card-body">
              <div class="d-flex align-items-center gap-3 mb-3">
                <div class="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
                     style="width:50px; height:50px; background: linear-gradient(90deg,#6366f1,#a855f7);">
                  {{ employee.initials }}
                </div>
                <div>
                  <div class="fw-semibold">{{ employee.name }}</div>
                  <!-- <div class="text-muted small">{{ employee.role }}</div> -->
                  <!-- <div class="text-muted small">{{ employee.id }}</div> -->
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <!-- <div class="text-muted small">
                  <i class="bi bi-building me-1"></i>{{ employee.department }}
                </div> -->
                <span
                  class="badge px-3 py-1 rounded-pill text-capitalize"
                  :class="{
                    'bg-success-subtle text-success': employee.status === 'active',
                    'bg-info-subtle text-info': employee.status === 'probation',
                    'bg-secondary-subtle text-secondary': employee.status !== 'active' && employee.status !== 'probation'
                  }"
                >
                  {{ employee.status }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Employee Profile -->
    <div v-if="fetchEmployeeLoading" class="text-center my-4">
        <div class="spinner-border text-primary" role="status" style="width:3rem; height:3rem;">
            <span class="visually-hidden">Loading...</span>
        </div>
        <div class="mt-2 text-muted">Fetching employee details...</div>
    </div>
    <div v-else-if="expandedEmployeeId" class="col-12">
      <div class="card border-0 shadow-sm rounded-4 mt-4">
        <div class="card-header bg-white fw-bold fs-5 border-0">
          Employee Profile - {{ employee.name }}
        </div>
        <div class="card-body">
          <!-- Tabs -->
            <ul class="nav mb-4 p-2 rounded-3 d-flex w-100" style="background-color:#f3f4f6;">
                <li 
                    v-for="tab in detailTabs" 
                    :key="tab" 
                    class="nav-item flex-fill text-center"
                >
                    <button
                    class="nav-link w-100 px-4 py-2 fw-semibold"
                    :class="activeTab === tab ? 'active-tab' : 'inactive-tab'"
                    @click="activeTab = tab"
                    >
                    {{ tab }}
                    </button>
                </li>
            </ul>


            <!-- Identity Section -->
            <!-- Identity -->
            <div v-if="activeTab === 'Identity'" class="row g-3">
                <div class="col-md-6">
                    <label class="form-label fw-semibold">Legal Name *</label>
                    <input
                    type="text"
                    class="form-control rounded-3"
                    placeholder="Enter legal name"
                    v-model="employee.legalName"
                    :disabled="true"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label fw-semibold">Preferred Name</label>
                    <input
                    type="text"
                    class="form-control rounded-3"
                    placeholder="Enter preferred name"
                    v-model="employee.name"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label fw-semibold">Date of Birth *</label>
                    <input
                    type="date"
                    class="form-control rounded-3"
                    v-model="employee.dob"
                    :disabled="true"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label fw-semibold">Employee Status *</label>
                    <select class="form-select rounded-3" v-model="employee.employeeStatus">
                    <option>Active</option>
                    <option>Pending</option>
                    <option>Probation</option>
                    <option>Resigned</option>
                    <option>Terminated</option>
                    </select>
                </div>
            </div>


        <!-- Contact Section -->
        <!-- Contact -->
        <div v-if="activeTab === 'Contact'" class="row g-3">
            <div class="col-md-6">
                <label class="form-label fw-semibold">Personal Email *</label>
                <input
                type="email"
                class="form-control rounded-3"
                v-model="employee.personalEmail"
                :disabled="true"
                />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Work Email *</label>
                <input
                type="email"
                class="form-control rounded-3"
                v-model="employee.email"
                />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Mobile Number *</label>
                <input
                type="text"
                class="form-control rounded-3"
                v-model="employee.mobileNumber"
                :disabled="true"
                />
            </div>

            <!-- <div class="col-md-6">
                <label class="form-label fw-semibold">Photo</label>
                <div class="d-flex align-items-center gap-2">
                <button class="btn btn-outline-secondary rounded-pill">Upload Photo</button>
                <span class="text-muted small" v-if="!employee.photoUrl">No photo uploaded</span>
                <img v-else :src="employee.photoUrl" alt="Photo" style="height:40px" />
                </div>
            </div> -->

            <div class="col-12">
                <label class="form-label fw-semibold">Home Address *</label>
                <textarea
                class="form-control rounded-3"
                rows="2"
                v-model="employee.homeAddress"
                :disabled="true"
                ></textarea>
            </div>

            <!-- Emergency Contacts Section -->
            <!-- <div v-if="employee.emergencyContacts && employee.emergencyContacts.length > 0">
                <div class="col-12">
                    <hr style="margin-top:10px; margin-bottom:20px;" />
                    <h6 class="fw-bold">Emergency Contacts (At least one required)</h6>
                </div>

                <div class="col-md-4">
                    <label class="form-label fw-semibold">Contact Name *</label>
                    <input
                    type="text"
                    class="form-control rounded-3"
                    v-model="employee.emergencyContacts[0].name"
                    :disabled="true"
                    />
                </div>

                <div class="col-md-4">
                    <label class="form-label fw-semibold">Relationship *</label>
                    <input
                    type="text"
                    class="form-control rounded-3"
                    v-model="employee.emergencyContacts[0].relationship"
                    :disabled="true"
                    />
                </div>

                <div class="col-md-4">
                    <label class="form-label fw-semibold">Phone Number *</label>
                    <input
                    type="text"
                    class="form-control rounded-3"
                    v-model="employee.emergencyContacts[0].phone"
                    :disabled="true"
                    />
                </div>
            </div> -->

        </div>



        <!-- Job Info -->
        <div v-if="activeTab === 'Job Info'" class="row g-3">
            <div class="col-md-6">
                <label class="form-label fw-semibold">Job Title *</label>
                <input class="form-control rounded-3" v-model="employee.position" />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Grade/Level</label>
                <input class="form-control rounded-3" v-model="employee.gradeLevel" />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Department *</label>
                <input class="form-control rounded-3" v-model="employee.department" />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Cost Centre</label>
                <input class="form-control rounded-3" v-model="employee.costCentre" />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Manager</label>

                <!-- Vue Select -->
                <v-select
                    v-model="employee.managerId"
                    :options="employees"
                    label="name"
                    :reduce="manager => manager.id"
                    placeholder="Type or select manager"
                >
                    <!-- Custom Option Template -->
                    <template #option="{ name, id }">
                        <div class="d-flex justify-content-between align-items-center">
                        <span>{{ name }}</span>
                        <small class="text-muted ms-2">({{ id }})</small>
                        </div>
                    </template>

                    <!-- Selected Option Template -->
                    <template #selected-option="{ name }">
                        <span>{{ name }}</span>
                    </template>
                </v-select>
            </div>


            <div class="col-md-6">
                <label class="form-label fw-semibold">Employment Type *</label>
                <select class="form-select rounded-3" v-model="employee.employmentType">
                <option>Permanent</option>
                <option>Contract</option>
                <option>Intern</option>
                <option>Part-time</option>
                </select>
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Work Arrangement *</label>
                <select class="form-select rounded-3" v-model="employee.workArrangement">
                <option>Hybrid</option>
                <option>Onsite</option>
                <option>Remote</option>
                </select>
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Work Location/Site</label>
                <input class="form-control rounded-3" v-model="employee.workLocation" />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Join Date *</label>
                <input type="date" class="form-control rounded-3" v-model="employee.joinDate" />
            </div>

            <div class="col-md-6">
                <label class="form-label fw-semibold">Probation End Date</label>
                <input type="date" class="form-control rounded-3" v-model="employee.probationEndDate" />
            </div>

            <!-- <div class="col-md-6">
                <label class="form-label fw-semibold">Notice Period (months)</label>
                <input type="number" class="form-control rounded-3" v-model.number="employee.noticePeriod" />
            </div> -->
        </div>

<!-- 
        <div v-if="activeTab === 'Payroll'" class="payroll-section">
            <div class="row g-3 mb-4">
                <div class="col-md-12">
                <label class="form-label fw-semibold">Employment Basis *</label>
                <select v-model="employee.payroll.employmentBasis" class="form-select rounded-3">
                    <option value="fulltime">Full-time</option>
                    <option value="parttime">Part-time</option>
                </select>
                </div>
            </div>

            <template v-if="employee.payroll.employmentBasis === 'fulltime'">
                <div class="row g-3 mb-4">
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Base Salary Amount *</label>
                    <input type="number" class="form-control rounded-3" v-model.number="employee.payroll.baseSalary" />
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Currency *</label>
                    <select class="form-select rounded-3" v-model="employee.payroll.currency">
                        <option>SGD</option>
                    </select>
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Pay Schedule *</label>
                    <select class="form-select rounded-3" v-model="employee.payroll.paySchedule">
                        <option>Monthly</option>
                    </select>
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Payroll Generate Day *</label>
                    <input type="number" class="form-control rounded-3" placeholder="1,2,3" v-model.number="employee.payroll.generateDay" />
                    </div>
                    

                    <div class="col-md-6 d-flex align-items-center">
                    <label class="form-label fw-semibold me-3 mb-0">Attendance Required</label>
                    <div class="form-check form-switch">
                        <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="employee.payroll.attendanceRequired"
                        id="attendanceSwitchFulltime"
                        />
                    </div>
                    </div>
                </div>
                </template>

                <template v-else>
                <div class="row g-3 mb-4">
                    <div class="col-md-6">
                        <label class="form-label fw-semibold">Hourly Rate *</label>
                        <input type="number" class="form-control rounded-3" v-model.number="employee.payroll.hourlyRate" />
                    </div>
                    <div class="col-md-6">
                        <label class="form-label fw-semibold">Payroll Generate Weekday *</label>
                        <select class="form-select rounded-3" v-model="employee.payroll.generateWeekday">
                            <option>Mon</option>
                            <option>Tue</option>
                            <option>Wed</option>
                            <option>Thu</option>
                            <option>Fri</option>
                        </select>
                    </div>

                    <div class="col-md-6 d-flex align-items-center">
                        <label class="form-label fw-semibold me-3 mb-0">Attendance Required</label>
                        <div class="form-check form-switch">
                            <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="employee.payroll.attendanceRequired"
                            id="attendanceSwitchParttime"
                            />
                        </div>
                    </div>
                    
                </div>
                </template>

                <div class="section-block">
                <h6 class="fw-bold mb-3">Bank Details</h6>
                <div class="row g-3">
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Account Name *</label>
                    <input class="form-control rounded-3" v-model="employee.payroll.bankDetails.accountName" />
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Bank Name *</label>
                    <input class="form-control rounded-3" v-model="employee.payroll.bankDetails.bankName" />
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Branch Code</label>
                    <input class="form-control rounded-3" v-model="employee.payroll.bankDetails.branchCode" />
                    </div>
                    <div class="col-md-6">
                    <label class="form-label fw-semibold">Account Number *</label>
                    <input class="form-control rounded-3" v-model="employee.payroll.bankDetails.accountNumber" :disabled="true" />
                    </div>
                </div>
            </div>

     </div> -->
        <div v-if="activeTab === 'Compliance'" class="compliance-section">
            <div class="col-12" v-if="employee.compliance.leaveEntitlements.length">
                <h6 class="fw-bold mb-3">Leave Entitlements</h6>
                <div class="row g-3">
                    <div
                    class="col-md-6"
                    v-for="(leave, index) in employee.compliance.leaveEntitlements"
                    :key="index"
                    >
                    <div class="p-3 border rounded-3 bg-light">
                        <!-- Leave Type -->
                        <div class="fw-semibold mb-2">
                        <input
                            class="form-control form-control-sm rounded-3 fw-semibold"
                            v-model="leave.type"
                            placeholder="Leave Type (e.g. Annual Leave)"
                            disabled
                        />
                        </div>

                        <!-- Entitlement -->
                        <div class="mb-2">
                        <label class="form-label small">Entitlement (days)</label>
                        <input
                            v-model.number="leave.entitlement"
                            type="number"
                            class="form-control form-control-sm rounded-3"
                         
                        />
                        </div>

                        <!-- Balance -->
                        <div>
                        <label class="form-label small">Balance (days)</label>
                        <input
                            v-model.number="leave.balance"
                            type="number"
                            class="form-control form-control-sm rounded-3"

                        />
                        </div>
                    </div>
                    </div>
                </div>
                </div>

        </div>
        

        <!-- <div v-if="activeTab === 'Claims'" class="claims-section">

            <div class="section-block">
                <h6 class="fw-bold mb-3 mt-3">Employee Claims Management</h6>

                <div class="table-responsive">
                <table class="table table-bordered align-middle text-sm">
                    <thead class="table-light">
                    <tr>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Category</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Processed</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(claim, index) in claims" :key="index">
                        <td>{{ claim.date }}</td>
                        <td class="fw-semibold">{{ claim.description }}</td>
                        <td>{{ claim.category }}</td>
                        <td class="fw-bold">${{ claim.amount.toFixed(2) }}</td>
                        <td>
                        <span
                            class="badge"
                            :class="{
                            'bg-success': claim.status === 'approved',
                            'bg-secondary': claim.status === 'pending' ||claim.status === 'processed',
                            'bg-danger': claim.status === 'rejected'
                            }"
                        >
                            {{ claim.status }}
                        </span>
                        </td>
                        <td>
                            <template v-if="claim.processed === '-' && claim.status === 'approved'">
                                <button 
                                class="btn btn-sm btn-outline-primary"
                                @click="markProcessed(claim)"
                                >
                                Process
                                </button>
                            </template>
                            <template v-else>
                                {{ claim.processed }}
                            </template>
                        </td>
                        <td>
                        <div class="d-flex gap-2">
                            <button class="btn btn-sm btn-outline-secondary">Receipt</button>
                        </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-2">
                <div class="fw-semibold">
                    Total Claims Value: 
                    <span class="text-dark">
                    ${{ claims.reduce((sum, c) => sum + c.amount, 0).toFixed(2) }}
                    </span>
                </div>
                <div class="d-flex gap-2">
                    <button class="btn btn-outline-secondary btn-sm rounded-pill">
                    Export Claims
                    </button>
                    <button class="btn btn-outline-secondary btn-sm rounded-pill">
                    Submit New Claim
                    </button>
                </div>
                </div>
            </div>
        </div> -->
        <!-- Additional → System Access -->
        <div v-if="activeTab === 'Additional'" class="additional-section">
            <!-- System Access -->
            <div class="section-block mb-4">
                <h6 class="fw-bold mb-3">System Access</h6>
                <div class="row g-3">
                <div class="col-md-6 col-lg-4" v-for="(system, index) in systemAccess" :key="index">
                    <div class="card shadow-sm h-100">
                    <div class="card-body d-flex justify-content-between align-items-center">
                        <div>
                        <div class="fw-semibold">{{ system.name }}</div>
                        <small class="text-muted">{{ system.desc }}</small>
                        </div>
                        <div class="form-check form-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="system.enabled"
                            :id="'switch-' + index"
                        />
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
<!-- 
            <div class="section-block mb-4">
                <h6 class="fw-bold mb-3">Company Assets</h6>
                <div
                v-for="(asset, index) in companyAssets"
                :key="index"
                class="p-3 border rounded-3 mb-2"
                >
                <div class="fw-semibold">{{ asset.name }}</div>
                <div class="text-muted small">Serial: {{ asset.serial }}</div>
                <div class="text-muted small">Issued: {{ asset.issued }}</div>
                <span class="badge bg-info">{{ asset.condition }}</span>
                </div>
                <button class="btn btn-outline-secondary btn-sm rounded-pill mt-2">Add Asset</button>
            </div>

            <div class="section-block mb-4">
                <h6 class="fw-bold mb-3">Training & Licenses</h6>

                <div
                v-for="(training, tIndex) in trainings"
                :key="tIndex"
                class="p-3 border rounded-3 mb-2"
                >
                <div class="mb-2">
                    <label class="form-label fw-semibold">Training Name</label>
                    <input
                    type="text"
                    class="form-control form-control-sm rounded-3"
                    v-model="training.name"
                    placeholder="e.g. Data Protection Training"
                    />
                </div>

                <div class="mb-2">
                    <label class="form-label fw-semibold">Details</label>
                    <input
                    type="text"
                    class="form-control form-control-sm rounded-3"
                    v-model="training.details"
                    placeholder="e.g. Completed: Mar 1, 2023"
                    />
                </div>

                <div class="mb-2">
                    <label class="form-label fw-semibold">Status</label>
                    <select class="form-select form-select-sm rounded-3" v-model="training.status">
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                    <option value="Expired">Expired</option>
                    </select>
                </div>

                <div class="text-end">
                    <button class="btn btn-sm btn-outline-danger rounded-pill" @click="trainings.splice(tIndex, 1)">
                    Delete
                    </button>
                </div>
                </div>

                <button
                class="btn btn-outline-secondary btn-sm rounded-pill mt-3"
                @click="trainings.push({ name: '', details: '', status: 'Pending' })"
                >
                Add Training
                </button>
            </div> -->
        </div>


            <!-- Action Buttons -->
            <div class="d-flex gap-2 pt-3 border-top mt-4">
                <!-- Save Changes Button -->
                <button
                    class="btn text-white rounded-pill px-4 d-flex align-items-center justify-content-center"
                    style="background: linear-gradient(90deg,#a855f7,#ec4899);"
                    @click="updateEmployee"
                    :disabled="savingLoading"
                >
                    <span
                    v-if="savingLoading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                    ></span>
                    <span>{{ savingLoading ? 'Saving...' : 'Save Changes' }}</span>
                </button>

                <!-- Cancel Button -->
                <button
                    class="btn btn-outline-secondary rounded-pill px-4"
                    :disabled="savingLoading"
                >
                    Cancel
                </button>

                <!-- Delete Employee Button -->
                <button
                    class="btn btn-danger rounded-pill px-4"
                    @click="deleteEmployee"
                    :disabled="savingLoading"
                >
                    Delete Employee
                </button>
            </div>

        </div>
      </div>
      

    </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/components/Layout.vue';
import { getAuth, onAuthStateChanged } from "firebase/auth";
// import router from "@/router";
import { useToast } from 'vue-toastification'
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";



export default {
  name: "Employees",
  components: { Layout, vSelect},
  data() {
    return {
        fetchEmployeeLoading:false, 
        showAddModal: false,
        // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
        mainTab: "employee",   // renamed
        userID: "",
        token: "",
        expandedEmployeeId: "",
        savingLoading:false,
        // employee list for the card view
        employees: [],

        // single employee full detail when expanded
        employee: {},

        // tabs for the profile
        detailTabs: ["Identity", "Contact", "Job Info", "Compliance", "Additional"],
        activeTab: "Identity",

        // payroll basis toggle
        employmentBasis: "",

        // these will be filled from API
        allowances: [],
        payroll: {
            employmentBasis: "",
            baseSalary: null,
            currency: "SGD",
            paySchedule: "",
            generateDay: null,
            generateWeekday: "",
            attedanceRequired: false,
            hourlyRate: "",
            bankDetails: { accountName: "", bankName: "", branchCode: "", accountNumber: "" }
        },
        payrollHistory: [],
        claims: [],
        leaveEntitlements: [],
        systemAccess: [],
        companyAssets: [],
        trainings: [],
        managerSearch: "",
        managers: [],          // full employee list
        filteredManagers: [],  // filtered based on search
        newEmployee: {
            legalName: "",
            name: "",
            dob: "",
            employeeStatus: "Active",
            personalEmail: "",
            email: "",
            password:"",
            mobileNumber: "",
            homeAddress: "",
            position: "",
            department: "",
            managerId: "",
            employmentType: "Permanent",
            workArrangement: "Hybrid",
            workLocation: "",
            joinDate: "",
            probationEndDate: "",
            payroll: {
                employmentBasis: "fulltime",    // fulltime or parttime
                baseSalary: null,
                currency: "",
                paySchedule: "",                 // Monthly or Weekly
                generateDay: null,               // Day of month for Monthly
                generateWeekday: "",             // Mon - Fri for Weekly
                hourlyRate: null,
                attedanceRequired:false,
                bankDetails: {
                    accountName: "",
                    bankName: "",
                    branchCode: "",
                    accountNumber: ""
                }
            },
            leaveEntitlements: [
                { type: "Annual Leave", entitlement: 14 },
                { type: "Medical Leave", entitlement: 14 },
                { type: "Hospitalization Leave", entitlement: 60 },
                { type: "Off In Lieu", entitlement: 0 }
            ],
            // Default system access
            systemAccess: [
                { accessType:"CRM", name: "CRM Access", desc: "Access to customer relationship module", enabled: false },
                { accessType:"Meetings", name: "Meetings Access", desc: "Manage and schedule meetings", enabled: false },
                { accessType:"Tasks", name: "Task Access", desc: "View and assign tasks", enabled: false },
                { accessType:"Quotes", name: "Quotes Access", desc: "Create and manage quotations", enabled: false },
                { accessType:"HR", name: "HR Access", desc: "Full HR management control", enabled: false },
                { accessType:"JobManagement", name: "Job Management Access", desc: "Manage job postings and recruitment", enabled: false },
            ],
        },
    };
  },
  async mounted() {
    this.userID = this.$store.getters.getUserId;
    await this.checkAuthState();
    await this.fetchEmployees();
  }, setup() {
    const toast = useToast()

    return {
      toast
    }
  },

  methods: {
    async updateEmployee() {
        try {
            if (!this.expandedEmployeeId) {
            this.toast.error("No employee selected for update.");
            return;
            }

            const headers = await this.getAuthHeader();
            this.savingLoading = true;

            // 🔹 Flatten systemAccess into a key-value object for backend
            const flatSystemAccess = {};
            this.systemAccess.forEach(access => {
            flatSystemAccess[access.accessType] = access.enabled;
            });

            // 🔹 Prepare final payload
            const payload = {
            // ===== Profile =====
            legalName: this.employee.legalName,
            name: this.employee.name,
            dob: this.employee.dob,
            employeeStatus: this.employee.employeeStatus,

            // ===== Contact =====
            personalEmail: this.employee.personalEmail,
            Email: this.employee.email, // backend expects capitalized "Email"
            mobileNumber: this.employee.mobileNumber,
            homeAddress: this.employee.homeAddress,
            emergencyContacts: this.employee.emergencyContacts || [],

            // ===== Job Info =====
            position: this.employee.position,
            department: this.employee.department,
            managerId: this.employee.managerId,
            employmentType: this.employee.employmentType,
            workArrangement: this.employee.workArrangement,
            workLocation: this.employee.workLocation,
            joinDate: this.employee.joinDate,
            probationEndDate: this.employee.probationEndDate,
            gradeLevel: this.employee.gradeLevel,
            costCentre: this.employee.costCentre,

            // ===== Payroll =====
            payroll: {
                employmentBasis: this.employee.payroll.employmentBasis,
                baseSalary: this.employee.payroll.baseSalary,
                currency: this.employee.payroll.currency,
                paySchedule: this.employee.payroll.paySchedule,
                generateDay: this.employee.payroll.generateDay,
                generateWeekday: this.employee.payroll.generateWeekday,
                hourlyRate: this.employee.payroll.hourlyRate,
                attedanceRequired: this.employee.payroll.attendanceRequired || false,
                bankDetails: {
                accountName: this.employee.payroll.bankDetails.accountName,
                bankName: this.employee.payroll.bankDetails.bankName,
                branchCode: this.employee.payroll.bankDetails.branchCode,
                accountNumber: this.employee.payroll.bankDetails.accountNumber
                }
            },

            // ===== Compliance (Leave Entitlements) =====
            leaveEntitlements: this.employee.compliance.leaveEntitlements.map(leave => ({
                type: leave.type,
                entitlement: leave.entitlement,
                balance: leave.balance ?? leave.entitlement // Default balance to entitlement
            })),

            // ===== System Access =====
            ...flatSystemAccess
            };

            console.log("Update Payload:", payload);

            // 🔹 Send PUT request
            const response = await axios.put(
            `${this.apiURL}/updateEmployee/${this.expandedEmployeeId}`,
            payload,
            { headers }
            );

            if (response.data.code === 200) {
            this.toast.success("Employee updated successfully!");
            await this.fetchEmployeeDetails(this.expandedEmployeeId); // refresh data
            } else {
            this.toast.error(response.data.message || "Failed to update employee.");
            }
        } catch (error) {
            console.error("Error updating employee:", error);
            this.toast.error(error.response?.data?.message || "Server error while updating employee.");
        } finally {
            this.savingLoading = false;
        }
        },
    async deleteEmployee() {
        try {
            this.savingLoading = true;
            const headers = await this.getAuthHeader();

            const response = await axios.delete(
            `${this.apiURL}/deleteEmployee/${this.expandedEmployeeId}`,
            { headers }
            );

            if (response.data.code === 200) {
            this.toast.success("Employee deleted successfully!");
            this.fetchEmployees(); // Refresh list
            } else {
            this.toast.error(response.data.message || "Failed to delete employee");
            }
        } catch (error) {
            console.error("Error deleting employee:", error);
            this.toast.error(error.response?.data?.message || "Server error while deleting employee");
        }finally{
            this.expandedEmployeeId=""
            this.savingLoading = false;

        }
    },
    async fetchEmployeeDetails(employeeId) {
        try {
            const headers = await this.getAuthHeader(); // 🔹 Generate token
            this.fetchEmployeeLoading = true;

            const response = await axios.get(
            `${this.apiURL}/getEmployee/${employeeId}`,
            { headers }
            );

            if (response.data.code === 200) {
            const employeeData = response.data.data;

            // ✅ Map everything correctly
            this.employee = {
                id: response.data.employeeID,

                // ===== Profile =====
                legalName: employeeData.profile.legalName,
                name: employeeData.profile.Name, // Backend sends capitalized key
                dob: employeeData.profile.dob,
                employeeStatus: employeeData.profile.employeeStatus,

                // ===== Contact =====
                personalEmail: employeeData.contact.personalEmail,
                email: employeeData.contact.Email, // Backend sends capitalized key
                mobileNumber: employeeData.contact.mobileNumber,
                homeAddress: employeeData.contact.homeAddress,
                emergencyContacts: employeeData.contact.emergencyContacts || [],

                // ===== Job Info =====
                position: employeeData.jobInfo.position,
                department: employeeData.jobInfo.department,
                managerId: employeeData.jobInfo.managerId,
                employmentType: employeeData.jobInfo.employmentType,
                workArrangement: employeeData.jobInfo.workArrangement,
                workLocation: employeeData.jobInfo.workLocation,
                joinDate: employeeData.jobInfo.joinDate,
                probationEndDate: employeeData.jobInfo.probationEndDate,
                gradeLevel: employeeData.jobInfo.gradeLevel|| "",
                costCentre: employeeData.jobInfo.costCentre|| "",

                // ===== Payroll =====
                payroll: {
                employmentBasis: employeeData.payroll.employmentBasis,
                baseSalary: employeeData.payroll.baseSalary,
                currency: employeeData.payroll.currency,
                paySchedule: employeeData.payroll.paySchedule,
                generateDay: employeeData.payroll.generateDay,
                generateWeekday: employeeData.payroll.generateWeekday,
                hourlyRate: employeeData.payroll.hourlyRate,
                attendanceRequired: employeeData.payroll.attedanceRequired || false, // typo fix
                bankDetails: {
                    accountName: employeeData.payroll.bankDetails.accountName,
                    bankName: employeeData.payroll.bankDetails.bankName,
                    branchCode: employeeData.payroll.bankDetails.branchCode,
                    accountNumber: employeeData.payroll.bankDetails.accountNumber
                }
                },

                // ===== Compliance =====
                compliance: {
                createdAt: employeeData.compliance.createdAt,
                updatedAt: employeeData.compliance.updatedAt,
                leaveEntitlements: employeeData.compliance.leaveEntitlements || []
                },

                // ===== Additional =====
                additional: {
                trainings: employeeData.additional.trainings || [],
                createdAt: employeeData.additional.createdAt,
                updatedAt: employeeData.additional.updatedAt
                }
            };

            // ======================================================
            // 🔹 Map systemAccess flat doc → array for UI v-for loop
            // ======================================================
            const sa = employeeData.systemAccess || {};
            const pick = (key, aliases = []) => {
                for (const k of [key, ...aliases]) {
                if (Object.prototype.hasOwnProperty.call(sa, k)) return !!sa[k];
                }
                return false;
            };

            this.systemAccess = [
                { accessType: "CRM",           name: "CRM Access",            desc: "Access to customer relationship module", enabled: pick("CRM") },
                { accessType: "Meetings",      name: "Meetings Access",       desc: "Manage and schedule meetings",           enabled: pick("Meetings") },
                { accessType: "Tasks",          name: "Task Access",           desc: "View and assign tasks",                  enabled: pick("Task", ["Tasks"]) },
                { accessType: "Quotes",        name: "Quotes Access",         desc: "Create and manage quotations",           enabled: pick("Quotes") },
                { accessType: "HR",            name: "HR Access",             desc: "Full HR management control",             enabled: pick("HR") },
                { accessType: "JobManagement", name: "Job Management Access", desc: "Manage job postings and recruitment",    enabled: pick("JobManagement", ["Job Management"]) }
            ];

            // Optional: store timestamps for reference
            this.systemAccessMeta = {
                createdAt: sa.createdAt || null,
                updatedAt: sa.updatedAt || null
            };

            this.toast.success("Employee data loaded successfully!");
            } else {
            this.toast.error(response.data.message || "Failed to fetch employee data.");
            }
        } catch (error) {
            console.error("Error fetching employee details:", error);
            this.toast.error(error.response?.data?.message || "An error occurred while fetching employee details.");
        } finally {
            this.fetchEmployeeLoading = false;
        }
        },
    async createEmployee() {
        this.savingLoading = true;
        try {
            if (!this.newEmployee.password || this.newEmployee.password.length < 6) {
                this.toast.error("Password must be at least 6 characters long");
                return;
            }
            const headers = await this.getAuthHeader();

            // 🔹 Transform systemAccess array to flat key-value
            const flatSystemAccess = {};
            this.newEmployee.systemAccess.forEach(access => {
                flatSystemAccess[access.accessType] = access.enabled;
            });

            // 🔹 Final payload to backend
            const payload = {
            ...this.newEmployee,
            ...flatSystemAccess  // merge flattened access into top-level
            };

            // 🔹 Send request
            const response = await axios.post(`${this.apiURL}/createEmployee`, payload, { headers });

            console.log("Employee Created:", response.data);
            this.toast.success("Employee created successfully!");
            this.fetchEmployees();
            this.showAddModal = false;
            this.newEmployee= {
                legalName: "",
                name: "",
                dob: "",
                employeeStatus: "Active",
                personalEmail: "",
                email: "",
                password:"",
                mobileNumber: "",
                homeAddress: "",
                position: "",
                department: "",
                managerId: "",
                employmentType: "Permanent",
                workArrangement: "Hybrid",
                workLocation: "",
                joinDate: "",
                probationEndDate: "",
                // payroll: {
                //     employmentBasis: "fulltime",    // fulltime or parttime
                //     baseSalary: null,
                //     currency: "",
                //     paySchedule: "",                 // Monthly or Weekly
                //     generateDay: null,               // Day of month for Monthly
                //     generateWeekday: "",             // Mon - Fri for Weekly
                //     hourlyRate: null,
                //     attedanceRequired:false,
                //     bankDetails: {
                //         accountName: "",
                //         bankName: "",
                //         branchCode: "",
                //         accountNumber: ""
                //     }
                // },
                leaveEntitlements: [
                    { type: "Annual Leave", entitlement: 14 },
                    { type: "Medical Leave", entitlement: 14 },
                    { type: "Hospitalization Leave", entitlement: 60 },
                    { type: "Off In Lieu", entitlement: 0 }
                ],
                // Default system access
                systemAccess: [
                    { accessType:"CRM", name: "CRM Access", desc: "Access to customer relationship module", enabled: false },
                    { accessType:"Meetings", name: "Meetings Access", desc: "Manage and schedule meetings", enabled: false },
                    { accessType:"Tasks", name: "Task Access", desc: "View and assign tasks", enabled: false },
                    { accessType:"Quotes", name: "Quotes Access", desc: "Create and manage quotations", enabled: false },
                    { accessType:"HR", name: "HR Access", desc: "Full HR management control", enabled: false },
                    { accessType:"JobManagement", name: "Job Management Access", desc: "Manage job postings and recruitment", enabled: false },
                ],
            }
        } catch (error) {
            console.error("Error creating employee:", error.response?.data || error.message);
            this.toast.error(error.response?.data.error || "Failed to create employee");
        }finally {
            this.savingLoading = false; // Stop spinner
             
        }
    },
    async fetchEmployees() {
        try {
        // 🔹 Step 1: Get Auth Header
        const headers = await this.getAuthHeader();

        // 🔹 Step 2: Make API Call with Axios
        const response = await axios.get(`${this.apiURL}/api/employees`, { headers });

        const result = response.data;

        // 🔹 Step 3: Handle Errors
        if (result.code !== 200) {
            this.toast.error(result.message || "Failed to fetch employees.");
            return;
        }

        // 🔹 Step 4: Update Local Data
        this.employees = result.employees.map(emp => ({
            id: emp.id,
            legalName: emp.legalName,
            name: emp.name,
            dob: emp.dob,
            employeeStatus: emp.employeeStatus,
            createdAt: emp.createdAt,
            updatedAt: emp.updatedAt,
            initials: emp.name ? emp.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() : 'N/A',
            department: emp.department || "Unassigned",
            role: emp.position || "Unknown",
            status: emp.employeeStatus ? emp.employeeStatus.toLowerCase() : "pending"
        }));

        // this.toast.success(`Fetched ${this.employees.length} employees successfully`);
        } catch (error) {
        console.error("Error fetching employees:", error);
        this.toast.error("An error occurred while fetching employees.");
        }
    },
    selectEmployee(employeeData) {
        if (this.expandedEmployeeId != employeeData.id){
            this.employee = employeeData;
            this.expandedEmployeeId = employeeData.id;
            this.fetchEmployeeDetails(employeeData.id);
        }
    },
    async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');
      const token = await user.getIdToken();
      return { Authorization: token };
    },
    async checkAuthState() {
      const auth = getAuth();
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            try {
              const idToken = await user.getIdToken();
              this.token = idToken;
              resolve();
            } catch (error) {
              reject(error);
            }
          } else {
            this.$router.push("/");  // safer in Options API
            reject(new Error("No user logged in"));
          }
        });
      });
    }
  }
};
</script>

<style>
.hover-shadow:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.hover-card:hover {
  transform: translateY(-2px);
  transition: all 0.2s ease-in-out;
}
.nav .nav-link {
  border-radius: 0.5rem; /* less round, more squarish */
  border: none;
  transition: all 0.2s ease-in-out;
}

.nav .active-tab {
  background-color: #ffffff !important;
  color: #111827 !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

.nav .inactive-tab {
  background-color: transparent;
  color: #6b7280; /* muted grey text */
}

.nav .inactive-tab:hover {
  background-color: #e5e7eb; /* light grey hover */
  color: #111827;
}

</style>
